import { render, staticRenderFns } from "./MultiRiTypeHelpList.vue?vue&type=template&id=c3ac03aa&"
import script from "./MultiRiTypeHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiRiTypeHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports